import React from 'react';
import { Box, Button } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import {
  InputContainer,
  SaveButtonContainer,
  FormContainer,
} from './HeaderRoleDuplicateInProgress.styles';

const HeaderRoleDuplicateInProgress = props => {
  const { values, handleChange, handleBlur, setFieldValue, error } = props;
  return (
    <FormContainer>
      <Box horizontal align="center" flow={5}>
        <InputContainer>
          <InputText
            id="name"
            placeholder="Enter the name"
            type="name"
            bgType="secondary"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            shouldErrorTakeSpace
            error={error}
          />
        </InputContainer>
        <SaveButtonContainer>
          <Button
            type="submit"
            btnType="invisible"
            noMargin
            size="small"
            disabled={!!error}
          >
            Save
          </Button>
        </SaveButtonContainer>
      </Box>
    </FormContainer>
  );
};

export default HeaderRoleDuplicateInProgress;
